<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="text-xs-center">
        <v-dialog @keydown.esc="closeInformationDialog"
                max-width="800"
                persistent
                v-model="$store.getters.submitInformationDialog"
        >
            <v-card>
                <v-card-title
                        class="headline secondary white--text justify-center"
                        primary-title>
                    Στοιχεία Aνταλλαγής
                </v-card-title>

                <v-card-text>
                    <v-layout align-center fill-height justify-space-around row>
                        <v-card>
                            <v-card-title>
                                <v-icon class="mr-2">
                                    person
                                </v-icon>
                                Φοιτητής
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list dense v-if="exchangeStudentData.student">
                                <v-list-tile>
                                    <v-list-tile-content><b>'Ονομα :</b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{exchangeStudentData.student.firstname}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Επώνυμο: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{exchangeStudentData.student.lastname}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Προσωπικό E-mail: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        {{exchangeStudentData.student.personalEmail}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Αριθμός Κινητού Τηλεφώνου: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{exchangeStudentData.student.mobile}}
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>

                            <v-divider></v-divider>
                            <v-card-title>
                                <v-icon class="mr-2">
                                    format_list_bulleted
                                </v-icon>
                                Στοιχεία
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-list dense>
                                <v-list-tile>
                                    <v-list-tile-content><b>Μονάδες:</b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{utils.getCredit(book,null)}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content><b>Ημερομηνία Επιλογής: </b></v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        {{exchangeStudentData.exchangeDestinationDateSelected}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-flex>
                                            <v-text-field class="mt-4"
                                                          color="info"
                                                          label="Κωδικός ανταλλαγής:"
                                                          prepend-icon="vpn_key"
                                                          v-model="exchangeCode"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <v-btn :disabled="loading4"
                                               :loading="loading4"
                                               @click="exchangePassword" color="info" outline round
                                               small
                                               v-if="!this.codeflag">
                                            Υποβολή
                                            <template slot="loader">
                                                <span class="custom-loader">
                                                  <v-icon light>cached</v-icon>
                                                </span>
                                            </template>
                                        </v-btn>
                                        <!--<v-btn @click="exchangePassword" color="info" outline round small-->
                                        <!--v-if="!this.codeflag">Πατήστε για τον κωδικό ανταλλαγής-->
                                        <!--</v-btn>-->
                                        <v-list-tile-content class="align-end" v-if="this.codeflag">
                                            <b>{{responseCode}}</b></v-list-tile-content>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content><b>
                                        <i>
                                            <small class="red--text">
                                                {{this.distPointInfo.msg2}}
                                            </small>
                                        </i>
                                    </b>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile>
                                    <v-list-tile-content class="mt-2">{{this.distPointInfo.msg1}}</v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>

                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="closeInformationDialog"
                            color="primary darken-0">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import requests from "../../requests";
    import utils from "../../utilities";

    export default {
        name: "SubmitInformationExchange",
        data() {
            return {
                utils,
                exchangeCode: '',
                loader: null,
                loading4: false,
                codeflag: false,
                code: '',
                distPointInfo: {
                    address: 'Π. ΡΑΛΛΗ KAI ΘΗΒΩΝ 250',
                    postalCode: '12244',
                    email: 'dianomipada2@gmail.com',
                    fax: '2102125456523',
                    mobilePhone: '698745413165',
                    phone: '210254645165',
                    name: '210254645165',
                    courier: 'ACS',
                    point: 'Πατήστε Εδώ',
                    units: '12,42',
                    date: '05/04/2019',
                    msg1: 'Η ανταλλαγή θα πρέπει να ολοκληρωθεί μέσα σε 5 ημέρες από την ημερομηνία που αναγράφεται παραπάνω ' +
                        '(\'Ημερομηνία Επιλογής\'). Μετά το πέρας της διορίας η επιλογή θα ακυρωθεί ' +
                        'αυτόματα και θα επανεκκινηθεί η διαδικασία επιλογής.',
                    msg2: 'Για την ολοκλήρωση της ανταλλαγής πρέπει να συμπληρω΄σετε τον ειδικό 8-ψήφιο κωδικό ανταλλαγής που θα σας δώσει ο παραπάνω φοιτητής.'

                }
            }
        },
        props: {
            studentBookId: Number,
            book: Object
        },
        methods: {
            closeInformationDialog() {
                this.$store.commit('setSubmitInformationDialog', false);
                this.codeflag = false;
            },
            callBackSuccessExchangeBooks(response){
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setlistForExchange', response);
                utils.setCounterExchangeBooks();

                var setMessageObject = {};
                setMessageObject.title = 'Ανταλλαγή Συγγράμματος';
                setMessageObject.message = 'Η ανταλλαγή του συγγράμματος [' + this.$store.getters.exchangeStudentData.book.id+ '], ' + this.$store.getters.exchangeStudentData.book.title + ' έχει ολοκληρωθεί με επιτυχία';
                setMessageObject.close = true;
                this.$store.commit('setMessageObject', setMessageObject);
                this.$store.commit('setMessageModal', true);
            },
            listOfExchangeBooks(){
                this.$store.commit('setLoadingModal', true);
                requests.listOfExchangeBooks(this.callBackSuccessExchangeBooks, this.onRequestErrors);
            },
            callBuckSuccessGetPin(response) {
                // this.code = response.dstPIN;
                // this.codeflag = true;
                // this.loading4 = false;
                this.loading4 = false;
                this.$store.commit('setSubmitInformationDialog', false);
                this.listOfExchangeBooks();
            },
            errorExchangeCodeDeliver(){
                this.exchangeCode = '';
                this.loading4 = false;
            },

            exchangePassword() {
                var exchangeCodeDeliverObject = {};
                exchangeCodeDeliverObject.dstPIN = this.exchangeCode;
                exchangeCodeDeliverObject.srcStatementBookId = this.studentBookId;
                this.loading4 = true;
                requests.exchangeCodeDeliver(exchangeCodeDeliverObject, this.callBuckSuccessGetPin, this.errorExchangeCodeDeliver);
            }
        },
        computed: {
            exchangeStudentData: function () {
                return this.$store.getters.exchangeStudentData
            },
            responseCode: function () {
                return this.code;
            }
        }
    }
</script>

<style>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>